import { Component, EventEmitter, Input, OnInit, Output, inject } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { EffIconComponent } from "../eff-icon/eff-icon.component";
import { EffTextareaFieldComponent } from "./eff-textarea-field.component";
import { EffCommentPopupComponent } from "../popups/eff-comment-popup/eff-comment-popup.component";

@Component({
    selector: "eff-textarea",
    templateUrl: "./eff-textarea.component.html",
    styleUrls: ["./eff-textarea.component.scss"],
    imports: [EffIconComponent, EffTextareaFieldComponent]
})
export class EffTextareaComponent implements OnInit {
    private _dialog = inject(MatDialog);

    @Input() label: string;
    @Input() popupTitle: string;
    @Input() model: any;
    @Input() uiid: string = "undefined";
    @Input() bordered: boolean = true;
    @Input() disabled: boolean = false;
    @Input() formController: FormControl = new FormControl();
    @Input() icon: string = "open_in_full";
    @Input() popupEnabled: boolean = true;

    @Output() modelChange: EventEmitter<any> = new EventEmitter();

    buttonUiid: string = "eff-popup-button";

    ngOnInit() {
        if (this.uiid) {
            this.buttonUiid += `-${this.uiid}`;
        }
    }

    onModelChanged(value) {
        this.modelChange.emit(value);
    }

    openPopup() {
        this._dialog.open(EffCommentPopupComponent, {
            data: {
                title: this.popupTitle,
                text: this.model,
                confirmButton: "Update changes",
                cancelButton: this.disabled ? "Close" : "Cancel",
                editAllowed: !this.disabled,
                confirm: this.confirm.bind(this),
            },
            panelClass: "eff-popup-wrapper",
            width: "70%",
            height: "70%",
        });
    }

    confirm(text: any) {
        this.model = text;
        this.formController.setValue(text);
        this.onModelChanged(text);
    }
}
